import {initCreateStore} from 'hiya-common/src/stores/index'

import reducer from '~/reducers'

export const createStore = initCreateStore(reducer)
export type StoreType = ReturnType<typeof createStore>
export type RootState = ReturnType<StoreType['getState']>
